import { createContext } from "react";

const initalAnnexureContext = {
    annexureViewFilter: null,
    annexureDefination: {isLoading: true,list: []},
    annexureTableRowData: {isLoading: true,data: {}},
    zoneDD:[],
    annexurePopupState:{open: false,rowId: false,initData: {},  tableInstanceData:{}},
  };
  
  export const AnnexureContext = createContext(initalAnnexureContext);
